import React, { Component } from "react";
import PropTypes from "prop-types";
import jobDetailStyle from "../../assets/jss/jobDetailStyle";
import { withStyles } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import "../../assets/css/jobDetail.css";
import Icon from "@material-ui/core/Icon";
import { Markup } from "interweave";
import FormModal from "./formModal";
import { connect } from "react-redux";
import { getJobDetail } from "../../actions/JobActions";
import { submitCv, openModal } from "../../actions/CvActions";

class JobDetail extends Component {

  constructor(props) {
    super(props);
    this.handleOnSubmit = this.handleOnSubmit.bind(this);
  }

  state = {
   // openModal: false,
    acceptTnC: false,
    considerOtherJobs: false,
    name: null,
    email: null,
    currentJobTitle: null,
    coverLetter: null,
    CV: null,
    cv_url: null,
    errorAlert: false,
    errors: {},
    job_id: null
  };

  componentWillMount() {
    this.setState({ job_id: this.props.match.params.job_id });
    this.props.getJobDetail(this.props.match.params.job_id);
  }

  handleOnSubmit(event) {
    this.props.submitCv(event, this.state.job_id);
   // this.setState({ openModal: false });
  }

  handleOpenModal = () => {
    //this.setState({ openModal: true });
    this.props.openModal(true)
  };

  handleCloseModal = () => {
    //this.setState({ openModal: false });
    this.props.openModal(false)
  };

  render() {
    const {
      classes,
      job_detail: { detail }
    } = this.props;
    return (
      <div>
        {detail && (
          <div className={classes.content}>
            <div className={classes.section}>
              <Grid container spacing={16}>
                <Grid item xs={12} sm container>
                  <Grid item xs container direction="column" spacing={16}>
                    <Grid item xs>
                      <Typography gutterBottom className={classes.title}>
                        {detail.title}
                      </Typography>

                      <Typography
                        className={classes.entity}
                      >
                        {detail.entity}
                      </Typography>

                      <div style={{ display: "inline-flex", marginBottom: '20px' }}>
                        {detail.category &&
                          detail.category.map((prop, key) => {
                            return (
                              <Typography
                                key={key}
                                color="textSecondary"
                              >
                                {prop}
                                {key < detail.category.length - 1 && ", "}
                                &nbsp;
                              </Typography>
                            );
                          })}
                      </div>


                      <Grid container direction="row">
                        <Grid container direction="row" style={{ width: 'auto', marginRight: '20px' }}>
                          <Icon className={classes.icon}>near_me</Icon>
                          <Typography className={classes.subText}>
                            {detail.location
                              ? detail.location
                              : "Yangon - Myanmar"}
                          </Typography>
                        </Grid>
                        <Grid container direction="row" style={{ width: 'auto', marginRight: '20px' }}>
                          <Icon className={classes.icon}>access_time</Icon>
                          <Typography className={classes.subText} style={{ textTransform: "capitalize" }}>
                            {detail.contract && detail.contract.type} Time
                        </Typography>
                        </Grid>
                        <Grid container direction="row" style={{ width: 'auto' }}>
                          <Icon className={classes.icon}>date_range</Icon>
                          <Typography className={classes.subText}>
                            Posted Date : {formatDate(detail._created)}
                          </Typography>
                          -
                        <Typography className={classes.subText}>
                            Closing Date : {formatDate(detail.close_date)}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </div>
            <hr className={classes.divider} />
            <div className={classes.section}>
              <h4 className={classes.title}>Job Description</h4>
              <Grid item>
                <div className={classes.demo}>
                  <Markup content={detail.description} />
                </div>
              </Grid>
            </div>
            <hr className={classes.divider} />
            <div className={classes.section}>
              <h4 className={classes.title}>Job Requirements</h4>
              <Grid item>
                <div className={classes.demo}>
                  <Markup content={detail.requirements} />
                </div>
              </Grid>
            </div>
            <hr className={classes.divider} />
            <div className={classes.section}>
              <h4 className={classes.title}>Benefits</h4>
              <Grid item>
                <div className={classes.benefits}>
                  {detail.benefits && detail.benefits.map((benefit, key) => (
                    <li key={key}>{benefit}</li>
                  ))}
                </div>
              </Grid>
            </div>

            <div className={classes.section}>
              <Button
                variant="contained"
                component="span"
                className={classes.applyBtn}
                onClick={this.handleOpenModal}
              >
                <Typography className={classes.btnText}>Apply Now</Typography>
              </Button>
            </div>

            <FormModal
              // open={this.state.openModal}
              open={this.props.cvs.open_modal}
              onClose={this.handleCloseModal}
              onSubmit={this.handleOnSubmit}
              classes={this.props.classes}
            />
          </div>
        )}
      </div>
    );
  }
}

JobDetail.propTypes = {
  classes: PropTypes.object.isRequired
};

function formatDate(string) {
  var options = { year: "numeric", month: "short", day: "numeric" };
  return new Date(string).toLocaleDateString([], options);
}

const mapDispatchToProps = (dispatch) => ({
  getJobDetail: id => {
    dispatch(getJobDetail(id));
  },
  submitCv: (event, job_id) => {
    dispatch(submitCv(event, job_id));
  },
  openModal: (value) => {
    dispatch(openModal(value))
  }
});

const mapStateToProps = state => ({
  job_detail: state.jobs,
  cvs: state.cvs
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(jobDetailStyle)(JobDetail));
